import { render, staticRenderFns } from "./ProductsName.vue?vue&type=template&id=033d828c&"
import script from "./ProductsName.vue?vue&type=script&lang=js&"
export * from "./ProductsName.vue?vue&type=script&lang=js&"
import style0 from "./ProductsName.vue?vue&type=style&index=0&id=033d828c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports